import {z} from 'zod';

export const osmIdSchema = z.number().int().finite();
